<template>
  <button @click="show" :aria-label="$t('buttons.rename')" :title="$t('buttons.rename')" class="action" id="rename-button">
    <edit-3-icon size="1.5x" class="custom-class"></edit-3-icon>
    <span>{{ $t('buttons.rename') }}</span>
  </button>
</template>

<script>

import { Edit3Icon } from 'vue-feather-icons';

export default {
  name: 'rename-button',
  components: {
    Edit3Icon
  },
  methods: {
    show: function () {
      this.$store.commit('showHover', 'rename');
    }
  }
};
</script>
